// Styles
import '../scss/main.scss';

// Scripts
import { offer } from '@shop/frontend/dist/desktop/index';

offer.getState(function (data) {
  if (data.query.cmp === 'false') {
    $('.logo-land').addClass('hidden');
  }
});
